<template>
    <div class="json-intent-wrap">
        <autosize-textarea
            v-if="readonly"
            v-model="localIntent"

            readonly
            codemode
        />

        <or-code
            v-else
            v-model="localIntent"

            mode="json"

            :full-screen="false"
            :invalid="!!($props.errors && $props.errors.json)"
            :error="$props.errors && $props.errors.json"
        />
    </div>
</template>

<script>
import autosizeTextarea from '../../autosize_textarea'

export default {
  components: {
    autosizeTextarea
  },

  props: {
    intent: String,
    readonly: Boolean,
    errors: {
      json: String
    }
  },

  computed: {
    localIntent: {
      get () {
        return this.intent
      },
      set (value) {
        this.$emit('update:intent', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .json-intent-wrap {
        display: flex;
        flex-grow: 1;
        ::v-deep .or-code {
            width: 100%;
        }
        ::v-deep .wrapper>.editor {
            font-family: unset;
            font-weight: normal;
            font-size: 12px;
            color: rgb(30, 35, 43);
            letter-spacing: 0;
            line-height: 16px;
        }
    }
</style>
